<template>
    <div class="ibox systemlog">
        <div class="ibox-content elevation-4" style="border-radius: 8px;">
            <h2 style="margin: 10px 10px 18px;">{{ t_title }}</h2>
            <table class="table table-striped table-bordered dataTable dtr-inline" aria-label="systemlog table">
                <thead>
                    <tr>
                        <th>{{ t_date }}</th>
                        <th>{{ t_category }}</th>
                        <th>{{ t_type }}</th>
                        <th>{{ t_message }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="row in rows">
                        <td>
                            {{ row.date }}
                        </td>
                        <td>
                            {{ row.category }}
                        </td>
                        <td>
                            {{ row.type }}
                        </td>
                        <td v-html="row.msg"></td>
                    </tr>
                </tbody>
            </table>
            <div class="row no-margins p-h-xs" v-if="Object.keys(rows).length == 0">
                <div class="col-md-12 text-center">{{ t_no_data }}</div>
            </div>
            <client-detail-pagination
                    :page="page"
                    :pages="pages"
                    event="updateSystemlog"
            ></client-detail-pagination>
        </div>
    </div>
</template>
<script>
    import toaster from "../../common/toaster";

    export default {
        props: [
            'id',
            'limit'
        ],
        components: {
            clientDetailPagination: require('./pagination.vue').default,
        },
        data() {
            return {
                t_title: Lang.langGet("Systemlog"),
                t_date: Lang.langGet("Date"),
                t_category: Lang.langGet("Category"),
                t_type: Lang.langGet("Type"),
                t_message: Lang.langGet("Message"),
                t_no_data: Lang.langGet("No data available."),
                t_systemlog_load_error: Lang.langGet("Failed to load latest Systemlog entries!"),
                rows: {},
                page: 0,
                pages: 0
            }
        },
        methods: {
            loadData: function () {
                axios.post('/system/client-detail/systemlog', {
                    id: this.id,
                    page: this.page,
                    limit: this.limit
                }).then((response) => {
                    this.rows = response.data.rows;
                    this.pages = response.data.pages;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_systemlog_load_error);
                });
            }
        },
        mounted() {
            this.loadData();

            EaseEventBus.listen('updateSystemlog', (data) => {
                this.page = data;
                this.loadData();
            });
        }
    }
</script>
